import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ArrowDown = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="arrow-down"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.2624 13.4963L0.513101 2.93597C-0.171036 2.26421 -0.171036 1.17506 0.513102 0.503618C1.19663 -0.167874 2.30524 -0.167874 2.98872 0.503618L12.5002 9.84788L22.0113 0.503891C22.6951 -0.167602 23.8036 -0.167602 24.4871 0.503891C25.171 1.17538 25.171 2.26448 24.4871 2.93624L13.7377 13.4966C13.3958 13.8323 12.9481 14 12.5002 14C12.0521 14 11.6041 13.832 11.2624 13.4963Z" />
    </svg>
  );
};
/* eslint-enable max-len */
ArrowDown.defaultProps = {
  className: null,
};

ArrowDown.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ArrowDown;
